/**
 * useLoyaltyPointTransactions
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import LoyaltyPointTransactionsContext from './loyalty-point-transactions-context'

const useLoyaltyPointTransactions = () => {
  const context = useContext(LoyaltyPointTransactionsContext)
  return context
}

export default useLoyaltyPointTransactions
